export class SystemCurrency {
    Id: number;
    Code: string;
    Title: string;
    IsDefault: string;
    Currency: number;
}
